<template>
    <div class="text-editor">
        <div class="toolbar">
            <button type="button" @click="toggleBold"><b>B</b></button>
            <button type="button" @click="toggleItalic"><i>I</i></button>
            <button type="button" @click="toggleUnderline"><u>U</u></button>
            <button type="button" @click="markPlaceholder"><span class="material-symbols-outlined toolbarIcon">bolt</span></button>
            <button type="button" @click="enterPlaceholder"><span style="color: red" class="material-symbols-outlined toolbarIcon">bolt</span></button>
            <button type="button" @click="addLink"><span class="material-symbols-outlined toolbarIcon">link</span></button>
        </div>
        <editor-content :editor="editor" class="editor-content" />
        <button class="openModalButton" @click.prevent="openModal = true"><span class="material-symbols-outlined">fullscreen</span></button>
        <TextEditorModal 
            v-if="openModal" 
            :content="sharedData.props.text"
            :isOpen="openModal" 
            @close="openModal = false"
            @updateText="updateContent"
        />
        <xmlModal 
            v-if="openXmlModal" 
            :text="selectedText"  
            @close="openXmlModal = false" 
            @markPlaceholder="markPlaceholderWithModal"
        />
    </div>
</template>

<script>
export default {
    name: 'TextEditor',
    props: {
        sharedData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            openModal: false,
            openXmlModal: false,
            selectedText: '',
            editor: null // Initialize your editor instance here
        };
    },
    methods: {
        toggleBold() {
            this.editor.chain().focus().toggleBold().run();
        },
        toggleItalic() {
            this.editor.chain().focus().toggleItalic().run();
        },
        toggleUnderline() {
            this.editor.chain().focus().toggleUnderline().run();
        },
        markPlaceholder() {
            const placeholder = '[[placeholder]]';
            this.editor.chain().focus().insertContent(placeholder).run();
        },
        enterPlaceholder() {
            this.openXmlModal = true;
            this.selectedText = this.editor.state.selection.content().text;
        },
        addLink() {
            const url = prompt('Enter the URL');
            if (url) {
                this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
            }
        },
        updateContent(newContent) {
            this.$emit('update:sharedData', {
                ...this.sharedData,
                props: {
                    ...this.sharedData.props,
                    text: newContent
                }
            });
        },
        markPlaceholderWithModal() {
            const placeholder = `[[${this.selectedText}]]`;
            this.editor.chain().focus().insertContent(placeholder).run();
            this.openXmlModal = false;
        }
    }
}
</script>

<style scoped>
@import '../../../styles/addComponents.css';
</style>